<template>
  <div>
    <div class="flex align-items-center gap-2 mb-3">
      <Button label="Aggiorna elenco" icon="pi pi-refresh" class="p-button-text" :loading="loading" @click="$emit('refresh')" />
    </div>
    <p v-if="error" role="alert">{{ error }}</p>
    <section v-for="group in groups" :key="group.project" class="mb-4">
      <h4>{{ group.project }}</h4>
      <p v-if="group.unavailable" class="text-color-secondary">Documentazione non disponibile per questo progetto.</p>
      <DataTable v-else :value="group.items" dataKey="filename" :loading="group.loading" showGridlines responsiveLayout="scroll">
        <template #empty>Nessuna documentazione disponibile.</template>
        <Column field="title" header="Documento" />
        <Column field="filename" header="File Markdown" />
        <Column field="updated_at" header="Data aggiornamento">
          <template #body="{ data }">{{ formatFileDate(data.updated_at) }}</template>
        </Column>
        <Column header="Azioni">
          <template #body="{ data }">
            <Button label="Visualizza" icon="pi pi-book" class="p-button-sm p-button-outlined" :disabled="!data.filename"
              :aria-label="'Visualizza ' + data.filename" @click="$emit('open', data)" />
          </template>
        </Column>
      </DataTable>
    </section>
  </div>
</template>

<script>
export default {
  name: 'DocumentationCatalog',
  props: {
    groups: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
  emits: ['refresh', 'open'],
  methods: {
    formatFileDate(value) {
      if (!value) return '—'
      const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}:\d{2})(?::(\d{2}))?$/)
      if (!match) return String(value)
      return `${match[3]}/${match[2]}/${match[1]} ${match[4]}${match[5] ? ':' + match[5] : ''}`
    },
  },
}
</script>
